export default "__VITE_ASSET__CxqYFXN7__"